export class RouletteController {
	private scene;
	private hold;
	private menuController;

	public buttons;
	public menuButton;
	public rulesButton;
	public spinButton;
	public undoButton;
	public deleteButton;
	public infoButton;

	constructor(scene) {
		this.scene = scene;
		this.hold = null;
		this.buttons = [];
	}

	setControlActivity(activity) {
		console.log('setControlActivity(activity): ' + activity);
		if (this.menuController) {
			this.menuController.setControlActivity(activity);
		}
		if (this.buttons != null) {
			this.buttons.forEach(b => {
				if (b) b.interactable = activity;
			});
		}
	}
}
